const steps = [
  {
    number: '01',
    title: 'Contact & Consultation',
    description: 'Reach out for a free quote. We discuss your needs and schedule a site visit.'
  },
  {
    number: '02',
    title: 'Site Assessment',
    description: 'We evaluate your property and provide a detailed proposal with transparent pricing.'
  },
  {
    number: '03',
    title: 'Scheduling',
    description: 'We coordinate timing to minimize disruption to your business operations.'
  },
  {
    number: '04',
    title: 'Professional Execution',
    description: 'Our experienced crew completes the work efficiently with quality materials.'
  },
  {
    number: '05',
    title: 'Final Inspection',
    description: 'We walk through the completed project to ensure your complete satisfaction.'
  }
];

export default function ProcessTimeline() {
  return (
    <section className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-yellow-400 uppercase tracking-wider text-sm font-semibold mb-4">
            Our Process
          </p>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Oswald, sans-serif' }}>
            How We Work
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            A straightforward process designed for your convenience and peace of mind
          </p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="hidden lg:block absolute top-12 left-0 right-0 h-1 bg-gray-800"></div>
          <div className="hidden lg:block absolute top-12 left-0 h-1 bg-yellow-400" style={{ width: '80%' }}></div>

          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="flex flex-col items-center text-center">
                  <div className="w-24 h-24 bg-yellow-400 rounded-full flex items-center justify-center mb-6 relative z-10">
                    <span className="text-3xl font-bold text-black" style={{ fontFamily: 'Oswald, sans-serif' }}>
                      {step.number}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
